export default __webpack_public_path__ + "static/ruben_restrepo-f6ba29b892b15b8e030bff1970e0fa0a.png";